import React from 'react';
import LegacyLayout, { LayoutProps } from './Layout.legacy';
import AlphaLayout from './Layout.alpha';

const Component = process.env.IS_LEGACY ? LegacyLayout : AlphaLayout;
export default Component as React.FC<LayoutProps>;
export type { LayoutProps };
